import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useCurrency } from "@/context/CurrencyContext";

export default function ExchangeRateDialog({ open, onOpenChange }) {
  const { rate, rateMeta, apply } = useCurrency();
  const [value, setValue] = useState("");
  const [busy, setBusy] = useState(false);
  const isManual = rateMeta?.source === "Manual";

  useEffect(() => { if (open) setValue(rate ? String(rate) : ""); }, [open, rate]);

  async function run(fn, msg) {
    setBusy(true);
    try {
      const { data } = await fn();
      apply(data);
      toast.success(msg);
      onOpenChange(false);
      window.dispatchEvent(new CustomEvent("data:refresh"));
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Eroare");
    } finally { setBusy(false); }
  }

  function save() {
    const n = parseFloat(String(value).replace(",", "."));
    if (!(n >= 3 && n <= 10)) {
      toast.error("Cursul trebuie să fie între 3 și 10 lei pentru 1 €");
      return;
    }
    run(() => api.put("/admin/exchange-rate", { rate: Math.round(n * 10000) / 10000 }), "Curs manual salvat");
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="exchange-rate-dialog">
        <DialogHeader>
          <DialogTitle>Curs valutar</DialogTitle>
          <DialogDescription>Cursul folosit în toată aplicația pentru conversia EUR / lei.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <label className="text-xs uppercase tracking-widest text-slate-500">1 € = ? lei</label>
            <input data-testid="exchange-rate-input" inputMode="decimal" value={value} onChange={(e) => setValue(e.target.value)}
              className="mt-1 w-full border border-slate-200 rounded-lg px-3 py-2.5 text-lg tabular focus:outline-none focus:ring-2 focus:ring-[#0047FF]" />
          </div>
          <div className="text-xs text-slate-500" data-testid="exchange-rate-bnr">
            Curs BNR {rateMeta?.bnrDate ? `(${rateMeta.bnrDate.split("-").reverse().join("/")})` : ""}: <strong className="tabular">{rateMeta?.bnr ? Number(rateMeta.bnr).toFixed(4) : "—"}</strong> lei
          </div>
          <p className="text-xs text-slate-400">Sumele introduse în lei rămân neschimbate. Se recalculează doar echivalentul lor în euro, cu excepția tranzacțiilor cu curs propriu.</p>
          <button onClick={save} disabled={busy} data-testid="exchange-rate-save-btn"
            className="w-full bg-[#0047FF] hover:bg-[#003BD3] disabled:opacity-60 text-white font-medium py-2.5 rounded-lg transition-colors">
            Salvează
          </button>
          {isManual && (
            <button onClick={() => run(() => api.delete("/admin/exchange-rate"), "Revenit la cursul BNR")} disabled={busy} data-testid="exchange-rate-revert-btn"
              className="w-full border border-slate-200 hover:border-slate-400 py-2.5 rounded-lg text-sm font-medium transition-colors">
              Revino la cursul BNR automat
            </button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
